// Fee ShopMy adds to a brand budget increase, in percent. Must match the
// BrandSettings.budgetIncreaseTakeRate column default so a missing rate bills like a new brand.
const DEFAULT_BUDGET_INCREASE_TAKE_RATE = 15;

const getBudgetIncreaseTakeRate = brandSettings => brandSettings?.budgetIncreaseTakeRate ?? DEFAULT_BUDGET_INCREASE_TAKE_RATE;

module.exports = {
  DEFAULT_BUDGET_INCREASE_TAKE_RATE,
  getBudgetIncreaseTakeRate
};
